<template>

  <v-dialog
    v-model="mostrar"
    hide-overlay
    persistent
    width="500"
  >
    <v-card>
      <v-card-title class="headline primary lighten-1 white--text">{{titulo}}</v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" >
          <v-container grid-list-md>
            <v-layout row wrap v-if="this.resultado.totalImagens">
              <v-flex xs12>
                <h2 class="subheading">Quanditade de imagens do exame: {{resultado.totalImagens}}</h2>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-select
                  required
                  v-if="mostraPorPagina"
                  label="Imagens por Página"
                  v-bind:items="quantidadesPorPagina"
                  v-model="porPagina"
                  item-text="descricao"
                  item-value="id"
                  hint="Selecione a quantidade de imagens por página"
                  persistent-hint
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-select
                  required
                  label="Padrão de seleção das imagens"
                  v-bind:items="selecaoImages"
                  v-model="pular"
                  item-text="descricao"
                  item-value="id"
                  hint="Selecione o padrão de seleção de imagens"
                  persistent-hint
                ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="green--text darken-1" flat="flat" @click.native="fechar">Fechar</v-btn>
        <v-btn :disabled="!porPagina || !pular" class="primary" @click.native="imprimir">
          <v-icon class="mr-2">print</v-icon> Gerar Impressão</v-btn>
      </v-card-actions>

    </v-card>

  </v-dialog>

</template>

<script>
  import axios from 'axios'

  export default {
    name: 'impressao-dialog',
    props: {
      mostrar: false,
      resultado: {}
    },
    data: function () {
      return {
        titulo: 'Impressão de Imagens',
        valid: false,
        quantidadesPorPagina: [
          {id: '2', descricao: '2 imagens por página'},
          {id: '4', descricao: '4 imagens por página'},
          {id: '6', descricao: '6 imagens por página'},
          {id: '8', descricao: '8 imagens por página'},
          {id: '9', descricao: '9 imagens por página'},
          {id: '12', descricao: '12 imagens por página'},
          {id: '16', descricao: '16 imagens por página'},
          {id: '25', descricao: '25 imagens por página'}
        ],
        selecaoImages: [],
        porPagina: null,
        mostraPorPagina: true,
        pular: null,
        obrigatorioRules: v => !!v || 'Campo obrigatório'
      }
    },
    methods: {
      imprimir () {
        console.log('imprimir', this.resultado, this.porPagina)
        let link = `${axios.defaults.baseURL}/imprimir/${this.resultado.id}?porPagina=${this.porPagina}&pular=${this.pular}`
        console.log(link)
        window.open(link)
        this.fechar()
      },
      fechar () {
        this.$emit('update:mostrar', false)
      }
    },
    created () {
      if ((this.resultado.totalImagens && this.resultado.totalImagens < 30) ||
            this.resultado.modalidade === 'CR' ||
            this.resultado.modalidade === 'US') {
        this.selecaoImages.push({id: 1, descricao: 'Todas as imagens'})
      }

      if (this.resultado.modalidade === 'CR') {
        this.quantidadesPorPagina = [
            {id: '1', descricao: 'Imagem por página'}
        ]
        this.pular = 1
        this.porPagina = 1
        this.mostraPorPagina = false
      } else if (this.resultado.modalidade === 'US' || this.resultado.modalidade === 'OT') {
        this.quantidadesPorPagina.unshift({id: '1', descricao: 'Imagem por página'})
        this.pular = 1
      } else {
        for (let i = 2; i <= 10; i++) {
          this.selecaoImages.push({id: i, descricao: `Selecionar 1 a cada ${i} imagens`})
        }
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// ImpressaoDialog.vue?50157154